<template>
  <drag-btn
    v-if="tpId"
    :lockedX="true"
    :lockedY="false"
    :offset="[0, 0, 0, 0]"
    class="initial-class"
    :class="[type === 'left' ? 'radius-right' : 'radius-left']"
  >
    <div class="cus-live" @click="goLive">
      <img
        class="icon"
        :src="`${cdnPath}/zhibo/static/img/live-h5/common/icon-live.png`"
        alt=""
      />
      <span>返回直播</span>
    </div>
  </drag-btn>
</template>
<script>
import {
  isMiniApp,
  jumpLinkCopyCurrentQuery,
  parseQueryString,
} from '@/utils/utils'
import useIframe from '@/pages/study/composables/useIframe'
import dragBtn from './dragBtn.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'ProbackToLive',
  props: {
    type: {
      type: String,
      default: 'left',
    },
  },
  components: { dragBtn },
  data() {
    return {
      tpId: '',
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    trainFrameStore() {
      return useIframe()
    },
  },
  methods: {
    goLive() {
      if (isMiniApp('vzanlive') && history.length === 1) {
        // 微赞小程序webview历史栈为1 关闭webview页面 否则正常回退h5
        wx.miniProgram.navigateBack()
      } else {
        let params = this.$route.query
        const paramsKey = `params_${this.tpId}_${this.userInfo.id}`
        if (sessionStorage.getItem(paramsKey)) {
          const sessionParam = parseQueryString(
            sessionStorage.getItem(paramsKey)
          )
          params = { ...sessionParam, ...params }
          sessionStorage.removeItem(paramsKey)
        }
        window.location.href = jumpLinkCopyCurrentQuery(
          `/live/page/${this.tpId}`,
          params
        )
      }
    },
  },
  mounted() {
    if (this.trainFrameStore.isFrame) {
      this.tpId = void 0
    } else {
      this.tpId =
        Number(this.$route.query.ctpid) ||
        Number(this.$route.query.tpid) ||
        Number(this.$route.query.tpId)
    }
  },
}
</script>
<style lang="scss" scoped>
.cus-live {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-size: var(--set-font-size12);
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #006cff;
  line-height: 12px;
  .icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
}
.initial-class {
  height: 0.33rem;
  box-sizing: content-box;
  position: fixed;
  top: calc(100% - 2rem);
  font-size: 0.14rem;
  color: #006cff;
  z-index: 9989;
  touch-action: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #e6f1ff 0%, #f5f9ff 100%);
  box-shadow: 0.04rem 0.1rem 0.6rem 0.1rem rgba(0, 0, 0, 0.08);
  border-radius: 0 0.3rem 0.3rem 0;
  border: 0.04rem solid #ffffff;
  &.radius-right {
    min-width: 0.78rem;
    padding: 0 0.12rem 0 0.08rem;
    border-radius: 0 0.2rem 0.2rem 0;
    left: 0;
  }
  &.radius-left {
    min-width: 0.84rem;
    padding: 0 0.08rem 0 0.12rem;
    border-radius: 0.2rem 0 0 0.2rem;
    right: 0;
  }
  .wrap {
    display: flex;
    align-items: center;
  }
  .icon {
    width: 0.16rem;
    height: 0.16rem;
    margin-right: 0.04rem;
  }
  // .back-to-live {
  //   font-size: 16px;
  //   background: white;
  // }
}
</style>
